import { useEffect } from 'react';
// form
import { useFormContext } from 'react-hook-form';
// hooks
import useResponsive from '../../hooks/useResponsive';
// @mui
import { Stack, MenuItem, Typography, Grid } from '@mui/material';
// rhf
import { RHFSelect, RHFFileUploadField, RHFTextField } from '.';

// ----------------------------------------------------------------------

export default function RHFFileOrURL({ fieldName, fieldLabel, titleText, titleTextVariant='subtitle1', defaultOption = '파일', isDisabled = false, openFile, fullWidth = false }) {
  const { control, setValue, watch, getValues } = useFormContext();
  const isDesktop = useResponsive('up', 'sm');
  const selectFieldName = `FOU${fieldName}Type`;
  const urlFieldName = `FOU${fieldName}URL`;
  const fileFieldName = `FOU${fieldName}File`;

  useEffect(() => {
    if (selectFieldName && urlFieldName && fileFieldName) {
      setValue(selectFieldName, defaultOption === '파일' ? fileFieldName : urlFieldName);
    }
  }, [selectFieldName]);

  const optionWatch = watch(selectFieldName);

  return (
    <Stack>
      <Typography variant={titleTextVariant} sx={{ mb : 2 }}>
        {titleText}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <RHFSelect
            control={control}
            name={selectFieldName}
            label="유형 (파일/링크)"
            SelectProps={{ native: false }}
            disabled={isDisabled}
          >
            <MenuItem
              key={fileFieldName}
              value={fileFieldName}
              sx={{
                mx: 1,
                my: 0.5,
                borderRadius: 0.75,
                typography: 'body2',
              }}
            >
              파일
            </MenuItem>
            <MenuItem
              key={urlFieldName}
              value={urlFieldName}
              sx={{
                mx: 1,
                my: 0.5,
                borderRadius: 0.75,
                typography: 'body2',
              }}
            >
              링크
            </MenuItem>
          </RHFSelect>
        </Grid>
        <Grid item xs={12} sm={8}>
          {optionWatch === fileFieldName ? (
            <RHFFileUploadField
              name={fileFieldName}
              link
              label={`${fieldLabel} 파일 업로드`}
              item={{file: getValues(fileFieldName)}}
              openfile={() => openFile(getValues(fileFieldName))}
              placeholder="파일을 선택하세요"
              isDisabled={isDisabled}
            />
          ) : (
            <RHFTextField name={urlFieldName} label={`${fieldLabel} 링크`} placeholder="https://" disabled={isDisabled} />
          )}
        </Grid>
      </Grid>
    </Stack>
  );
}
